import React from 'react';

const Logo = ({ className = "h-8" }) => {
  return (
    <svg
      viewBox="0 -30 800 170"
      xmlns="http://www.w3.org/2000/svg"
      className={`group transition-all duration-300 hover:scale-105 hover:drop-shadow-md ${className}`}
    >
      {/* Bread Icon Group */}
      <g transform="translate(20, -20) scale(0.8)">
        {/* Little Hand (Waving from the right side) */}
        <path
          d="M 170,110 Q 210,90 200,60"
          fill="none"
          stroke="#222222"
          strokeWidth="12"
          strokeLinecap="round"
          className="origin-[170px_110px] group-hover:animate-wave-hand"
        />

        {/* Main Bread Outline (Crust) */}
        <path
          d="M 40,160 L 160,160 Q 175,160 175,140 L 175,70 C 185,20 135,10 100,30 C 65,10 15,20 25,70 L 25,140 Q 25,160 40,160 Z"
          fill="#FFFFFF"
          stroke="#222222"
          strokeWidth="12"
          strokeLinecap="round" 
          strokeLinejoin="round"
        />

        {/* Inner Spread (Inset Shape) */}
        <path
          d="M 45,150 L 155,150 Q 165,150 165,140 L 165,75 C 170,40 135,30 100,45 C 65,30 30,40 35,75 L 35,140 Q 35,150 45,150 Z"
          fill="#EAEAEA"
          stroke="none"
        />

        {/* Rotated Face Group */}
        <g transform="rotate(-10, 100, 100)">
          {/* Eyes */}
          <circle cx="75" cy="90" r="6" fill="#222222" />
          <circle cx="125" cy="90" r="6" fill="#222222" />

          {/* Mouth */}
          <path
            d="M80,115 Q100,130 120,115"
            fill="none"
            stroke="#222222"
            strokeWidth="8"
            strokeLinecap="round"
          />
        </g>
      </g>

      {/* Text */}
      <text x="210" y="90"
          fill="#222222"
          fontFamily="'Helvetica Rounded', Arial, sans-serif"
          fontWeight="bold"
          fontSize="54"
          letterSpacing="1">
        OFFICE ARENA
      </text>
    </svg>
  );
};

export default Logo;
